import React from 'react';
import { ToastContainer } from 'react-toastify';
import GivingCampaignDashboard from '../components/GivingCampaignDashboard';

const GivingCampaignDashboardApp = (props) => (
  <>
    <ToastContainer icon={false} />
    <GivingCampaignDashboard {...props} />
  </>
);

export default GivingCampaignDashboardApp;
